interface PhotoParams {
  url?: string;
  caption?: string;
  width?: number;
  height?: number;
  noPhoto?: boolean;
  isStreetView?: boolean;
}

class Photo {
  url: string;
  caption: string;
  noPhoto?: boolean;
  isStreetView?: boolean;

  constructor({
    url = '',
    caption = '',
    width = 0,
    height = 0,
    noPhoto = false,
    isStreetView = false,
  }: PhotoParams = {}) {
    this.url = String(url);
    this.caption = String(caption);

    if (noPhoto) {
      this.noPhoto = noPhoto;
    }

    if (isStreetView) {
      this.isStreetView = isStreetView;
    }
  }
}

export default Photo;
